{
  "schema_version": 1,
  "task_id": "L5-ECOSYSTEM-PUBLISHING-DOR-001",
  "status": "dor-only",
  "authority_boundary": {
    "dor_only": true,
    "publishing_enabled": false,
    "marketplace_submission": false,
    "plugin_install": false,
    "plugin_publish": false,
    "skill_publish": false,
    "site_publish": false,
    "external_distribution": false,
    "network_access": false,
    "oauth_flow": false,
    "secret_storage": false,
    "external_write": false,
    "paid_action": false,
    "legal_approval_assumed": false,
    "task_completion_authority": false
  },
  "publishing_readiness": [
    {
      "id": "product-purpose",
      "title_zh": "发布目的与用户价值",
      "title_en": "Publishing purpose and user value",
      "current_state": "blocked",
      "required_before_publish": [
        "clear user-facing purpose",
        "target audience selected by user",
        "non-goals documented",
        "success and rollback criteria"
      ],
      "forbidden_shortcut": "publish because artifact exists"
    },
    {
      "id": "license-and-attribution",
      "title_zh": "许可与署名",
      "title_en": "License and attribution",
      "current_state": "blocked",
      "required_before_publish": [
        "all third-party licenses enumerated",
        "attribution file generated",
        "incompatible license check",
        "user legal decision recorded"
      ],
      "forbidden_shortcut": "assume open source means publishable"
    },
    {
      "id": "security-review",
      "title_zh": "安全与 Secret 边界",
      "title_en": "Security and Secret boundary",
      "current_state": "blocked",
      "required_before_publish": [
        "secret scan pass",
        "permission manifest default deny",
        "external write inventory",
        "threat model and abuse cases"
      ],
      "forbidden_shortcut": "ship with broad permissions"
    },
    {
      "id": "quality-evidence",
      "title_zh": "质量证据",
      "title_en": "Quality evidence",
      "current_state": "blocked",
      "required_before_publish": [
        "lint pass",
        "typecheck pass",
        "unit and integration tests pass",
        "Evidence bundle complete"
      ],
      "forbidden_shortcut": "publish without reproducible validation"
    },
    {
      "id": "cost-and-account",
      "title_zh": "费用与账号选择",
      "title_en": "Cost and account choice",
      "current_state": "blocked",
      "required_before_publish": [
        "cost model visible",
        "publishing account selected by user",
        "quota and billing risk accepted",
        "no surprise paid action"
      ],
      "forbidden_shortcut": "implicit billing or account use"
    },
    {
      "id": "rollback-and-unpublish",
      "title_zh": "回滚与下架",
      "title_en": "Rollback and unpublish",
      "current_state": "blocked",
      "required_before_publish": [
        "versioned artifact snapshot",
        "unpublish path documented",
        "data deletion path documented",
        "rollback smoke test"
      ],
      "forbidden_shortcut": "publish without removal plan"
    },
    {
      "id": "user-approval",
      "title_zh": "用户明确批准",
      "title_en": "Explicit user approval",
      "current_state": "blocked",
      "required_before_publish": [
        "exact channel selected",
        "exact artifact version selected",
        "public text reviewed by user",
        "final publish approval recorded"
      ],
      "forbidden_shortcut": "infer publish approval from build approval"
    },
    {
      "id": "independent-review",
      "title_zh": "独立复审",
      "title_en": "Independent review",
      "current_state": "blocked",
      "required_before_publish": [
        "license review",
        "security review",
        "Evidence review",
        "rollback review"
      ],
      "forbidden_shortcut": "self-review publication"
    }
  ],
  "channels": [
    {
      "id": "project-local-skill",
      "status": "future-task",
      "allowed_effect": "local repository change only after Task Spec",
      "publish_now": false
    },
    {
      "id": "official-site-production",
      "status": "requires-deploy-task",
      "allowed_effect": "saved/deployed version only after user approval",
      "publish_now": false
    },
    {
      "id": "github-repository",
      "status": "requires-remote-write-approval",
      "allowed_effect": "branch/PR only after scope approval",
      "publish_now": false
    },
    {
      "id": "plugin-marketplace",
      "status": "requires-legal-and-account-approval",
      "allowed_effect": "submission only after legal/account/cost approval",
      "publish_now": false
    }
  ],
  "current_decision": {
    "can_publish_now": false,
    "reason": "Publishing DoR is defined, but all publication gates remain blocked pending user channel/artifact/legal/cost/account decisions and future Evidence.",
    "next_safe_task": "L5-ECOSYSTEM-PUBLISHING-UI-SURFACE-001"
  }
}

